export const GET_CLOUD_WORDS = 'GET_CLOUD_WORDS';
export const SET_CLOUD_WORDS = 'SET_CLOUD_WORDS';
export const ERROR_CLOUD_WORDS = 'ERROR_CLOUD_WORDS';